// v3/app/App.tsx — V3 entry point
// Imports tokens.css, wraps routes with AppProviders.
// Restores session synchronously before first render.
// Zero imports from v1/v2.

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter';
import '../../v3/design-system/tokens.css';
import { AppProviders } from './providers/AppProviders';
import { V3Routes } from './router/routes';
import { useAuthStore } from '../shared/stores/auth-store';
import { initTheme } from '../design-system/composites/ThemeToggle';

// These side effects must not run on v1/v2 routes: index.tsx imports V3App
// statically, so this module loads everywhere. Without the guard, data-v3 and
// the dark-mode class leak onto <html> and silently re-theme v1.
if (window.location.pathname.startsWith('/v3')) {
  // Restore session synchronously before React renders anything.
  // This ensures ProtectedRoute sees the correct isAuthenticated state on first render.
  useAuthStore.getState().restoreSession();

  // Scope the Meridian token bridge to the whole document while v3 is mounted.
  // Must be on <html>, not a wrapper div, so portalled Radix content (dialogs,
  // sheets, toasts) also resolves the [data-v3] variables in tokens.css.
  document.documentElement.setAttribute('data-v3', '');

  // Apply persisted light/dark mode (or the OS preference) before first paint.
  initTheme();
}

export function V3App() {
  return (
    <BrowserRouter basename="/v3">
      <AppProviders>
        <V3Routes />
      </AppProviders>
    </BrowserRouter>
  );
}
